<template>
  <div class="r-details-ipt common-flex common-justify-between">
    <div style="opacity:.7">{{config.label}}</div>
    <div>{{config.value||''}}</div>
  </div>
</template>

<script>
export default {
  name: "r-details-ipt",
  data() {
    return {};
  },
  props: {
    config: Object,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.r-details-ipt {
  width: 250px;
  padding: 12px 0;
  border-bottom: 1px solid #D9DCE1;
  font-size: 14px;
  font-family: Roboto, Roboto-Regular;
  font-weight: 400;
  text-align: right;
  color: #081938;
  line-height: 16px;
  margin-top: 13px;
  margin-right: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/r-details-ipt.vue